// Legacy code, just modularized

import $ from 'jquery';
import Mustache from 'mustache';

const jobSearch = {
  init: function() {
    if($('.job-search').length) {

      var search_result_template = document.getElementById('mustache-job-search-results-row').innerHTML;
      const includeJobCategories = $('.job-search--categorized').length > 0;

      var initListSorting = function(result) {
        var field_to_sort = '';

        var cloneObject = function(src) {
          return Object.assign({}, src);
        }

        // Sort rows by specified field
        var compare = function(a, b) {
          if(a[field_to_sort] < b[field_to_sort]) {
            return -1;
          } else if(a[field_to_sort] > b[field_to_sort]) {
            return 1;
          }
          return 0;
        }

        var result_sorting = cloneObject(result); // Clone object for safe manipulating
        result_sorting.only_rows = true; // Render only search result rows leaving title row unaffected

        var output = '';

        $('.column-title').on('click', function() {
          var $self = $(this);

          if($self.hasClass('asc')) {
            // Descending order

            field_to_sort = $self.data('sort');

            $('.column-title').removeClass('asc');
            $('.column-title').removeClass('desc');
            $self.addClass('desc');

            result_sorting.jobs.sort(compare).reverse();

            $('.result-row').remove(); // Remove search result rows before printing sorted rows
            output = Mustache.render(search_result_template, result_sorting);
            $self.parents('tr').parent().append(output); // Print sorted rows

          } else if($self.hasClass('desc')) {
            // Default order

            field_to_sort = 'default_position';

            $('.column-title').removeClass('asc');
            $('.column-title').removeClass('desc');

            result_sorting.jobs.sort(compare);

            $('.result-row').remove(); // Remove search result rows before printing sorted rows
            output = Mustache.render(search_result_template, result_sorting);
            $self.parents('tr').parent().append(output); // Print sorted rows

          } else if(!$self.hasClass('asc') && !$self.hasClass('desc')) {
            // Ascending order

            field_to_sort = $self.data('sort');

            $('.column-title').removeClass('asc');
            $('.column-title').removeClass('desc');
            $self.addClass('asc');

            result_sorting.jobs.sort(compare);

            $('.result-row').remove(); // Remove search result rows before printing sorted rows
            output = Mustache.render(search_result_template, result_sorting);
            $self.parents('tr').parent().append(output); // Print sorted rows
          }

        });
      };

      if(window.jobs && !includeJobCategories) {
        initListSorting(window.jobs);
      }

      // Location select dropdown visibility
      $('.location-select').on('click', function(e) {
        if(e.target === this || e.target === $(this).find('.location-select-text')[0] || e.target === $(this).find('.location-select-filters-count')[0]) {
          $(this).find('.location-dropdown').slideToggle(200);
          $(this).toggleClass('active');
        }
      });

      var searchJobs = function() {

        // Set loading animation height relative to content height and fade it in
        $('.row-loader-container').css('padding-top', ($('.row-loader-container').outerHeight() / 5) + 'px');
        $('.row-loader-container').fadeIn(200);

        var $selected_locations = $('.location-option.selected');
        var locations = [];

        $selected_locations.each(function() {
          locations.push($(this).data('value'));
        });

        $.ajax({
          url: '/stage-ajax/searchJobs/',
          type: 'GET',
          data: {
            search: $('#job-search').val().replace(/-/g, ' ').replace(/[^a-zA-Z0-9åäöÅÄÖ\s]/g, ''),
            locations: locations.length ? locations.join(';') : null,
            includeCategories: includeJobCategories ? 1 : 0,
            'stage-language': $('html').attr('lang')
          }
        }).done(function(result) {

          var output = Mustache.render(search_result_template, result);
          $('.search-result-container').html(output);

          $('.search-hits').text(result.hits);

          if(!includeJobCategories) {
            initListSorting(result);
          }
        });

      }

      $('#job-search-button').on('click', function() {
        searchJobs();
      });

      $('.search-input-form').on('submit', function(e) {
        e.preventDefault();
        searchJobs();
      });

      $('.location-option').on('click', function() {
        var $self = $(this);

        var $location_filter_count = $('.location-select-filters-count');

        // Add selection style class and create/remove filter instances
        if($self.hasClass('selected')) {
          $self.removeClass('selected');
          $('.active-location-filters').find('.filter-instance[data-id=' + $self.data('id') + ']').remove();
        } else {
          $self.addClass('selected');

          if(!$('.active-location-filters').find('.' + $self.data('id')).length) {
            $('.active-location-filters').append('<div class="filter-instance" data-id="' + $self.data('id') + '">' + $self.text() + '</div>');
          }
        }

        // Remove selection when clicking a filter instance
        $('.active-location-filters .filter-instance').on('click', function() {
          $('.location-option[data-id=' + $(this).data('id') + ']').removeClass('selected');
          $(this).remove();

          if($('.location-option.selected').length > 0) {
            $location_filter_count.show();
          } else {
            $location_filter_count.hide();
          }
          $location_filter_count.text($('.location-option.selected').length);

          searchJobs();
        });

        if($('.location-option.selected').length > 0) {
          $location_filter_count.show();
        } else {
          $location_filter_count.hide();
        }
        $location_filter_count.text($('.location-option.selected').length);

        searchJobs();
      });

    }
  }
};

export default jobSearch;
